import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
// 查看页面和编辑页面公用的参数和方法
import common from '@/views/visual/dataScreen/js/config';
import { config } from '@/views/visual/dataScreen/js/option/config';
import container from '@/views/visual/dataScreen/group/container'; // import { getList } from '@/api/visual/map'

import { getList } from '@/api/visual/map';
export default {
  components: {
    container: container
  },
  provide: function provide() {
    return {
      main: this,
      contain: this
    };
  },
  data: function data() {
    return {
      DIC: {
        MAP: []
      },
      contentWidth: '',
      config: config,
      obj: {},
      id: '',
      visual: {},
      nav: [],
      common: common,
      active: [],
      activeIndex: null,
      overactive: '',
      historyCache: [],
      // 历史操作数据用于undo redo
      currentHistoryIndex: -1,
      // redo undo 指针
      copyNav: '',
      // 用于监听去干扰,字符串类型,方便比较,
      configData: ['header', 'query']
    };
  },
  watch: {
    nav: {
      handler: function handler(val, oldval) {
        this.recordMain(val, oldval);
      },
      deep: true
    },
    config: {
      handler: function handler(val) {
        this.configData.concat(['url']).forEach(function (ele) {
          window.$glob[ele] = val[ele];
        });
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    list: function list() {
      var result = []; //循环处理数据

      var detail = function detail(item) {
        if (item.children) {
          item.children.forEach(function (ele) {
            detail(ele);
          });
        } else {
          result.push(item);
        }
      };

      this.nav.forEach(function (ele) {
        detail(ele);
      });
      var len = result.length - 1;
      result.forEach(function (ele, index) {
        ele.zIndex = len - index;
      });
      return result;
    },
    // 能否撤销
    canUndo: function canUndo() {
      return this.currentHistoryIndex > 0;
    },
    canRedo: function canRedo() {
      return this.historyCache.length > this.currentHistoryIndex + 1;
    }
  },
  created: function created() {
    this.initDic();
    console.log('enter created');
  },
  methods: {
    //初始化字典
    initDic: function initDic() {
      var _this = this;

      getList({
        current: 1,
        size: 100
      }).then(function (res) {
        var data = res.result;
        _this.DIC.MAP = data.records.map(function (ele) {
          return {
            label: ele.name,
            value: _this.$website.url + '/visual/map/data?id=' + ele.id
          };
        });
      });
    },
    findnav: function findnav(id, type) {
      var _this2 = this;

      //循环处理数据
      var obj = undefined;
      var count = 0;
      var parent = undefined;
      var pcount = 0;
      var len = 0;

      var detail = function detail(item, list, i) {
        var number = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

        if (!item.children || type) {
          if (id === item.index) {
            obj = item;
            len = Array.isArray(list) ? list.length - 1 : list.children.length - 1;
            parent = list;
            pcount = number;
            count = i;
          }
        }

        if (item.children) {
          item.children.forEach(function (ele, index) {
            detail(ele, item, index, number + 1);
          });
        }
      };

      this.nav.forEach(function (ele, index) {
        detail(ele, _this2.nav, index);
      });
      return {
        obj: obj,
        count: count,
        len: len,
        pcount: pcount,
        parent: parent
      };
    },
    findlist: function findlist(index) {
      return this.list.find(function (ele) {
        return ele.index == index;
      }) || {};
    },
    handleInitActive: function handleInitActive() {
      if (!this.active) return;
      this.active = [];
      this.activeIndex = null;
    },
    handleMouseDown: function handleMouseDown() {
      this.handleInitActive();
    },
    // =====================历史纪录=======================
    // 监听调用主程序
    recordMain: function recordMain(val, oldval) {
      //分两种情况:
      // 1. 版本在回撤时, 不要走监听(同时啥也没改)
      // 2. 版本回撤改了呢?那也要走监听重新推新的  
      if (JSON.stringify(val) != this.copyNav) {
        // 不一样的东西才值得记录
        // 这里监听不用deep,很多移动操作无法监听,但用了deep杂质很多,随便鼠标点一下就能触发监听
        // 注意不要这么判断 (val !== oldval)  因为很多时候新老值对比是一样的
        var newst = JSON.stringify(val);

        if (newst != this.copyNav) {
          // console.log('我不一样哦');
          this.copyNav = newst;
          this.addHistoryCache(val);
        } else {
          // console.log("一模一样,你记录个锤子啊!!");
          return;
        }
      }
    },

    /**
    * 新增一条历史纪录
    * @param 
    */
    addHistoryCache: function addHistoryCache(val) {
      if (this.currentHistoryIndex + 1 < this.historyCache.length) {
        this.historyCache.splice(this.currentHistoryIndex + 1);
      }

      this.historyCache.push({
        nav: this.deepClone(val) // activePageUUID: this.activePageUUID,
        // activeElementUUID: this.activeElementUUID

      }); // 限制undo 纪录步数，最多支持100步操作undo

      this.historyCache.splice(100);
      this.currentHistoryIndex++;
    },
    editorUndo: function editorUndo() {
      if (!this.canUndo) {
        return;
      }

      this.currentHistoryIndex--;
      this.relapceEditorState();
    },
    editorRedo: function editorRedo() {
      if (!this.canRedo) {
        return;
      }

      this.currentHistoryIndex++;
      this.relapceEditorState();
    },

    /**
    * 更新编辑器项目数据，从history中拿数据替换
    * @param data
    */
    relapceEditorState: function relapceEditorState() {
      var prevState = this.historyCache[this.currentHistoryIndex];
      this.nav = this.deepClone(prevState.nav); // 版本回退,本地保存一个,方便后面对比

      this.copyNav = JSON.stringify(prevState.nav);
    }
  }
};